/** Miert a Semmelweis script  */

jQuery(function ($) {
  //Carousel
  var owlPostCarousels = $(".post-slide .owl-carousel");
  var carousel = [];
  var numberOfItems = [];
  var nav0 = [];
    var stagePadding0 = [];

  owlPostCarousels.each(function (i, element) {
    carousel[i] = $(this);
    console.log("owl: ", carousel);
    numberOfItems[i] = 3;
    nav0[i]= false;
    stagePadding0[i]= Math.abs(numberOfItems[i] - 4) * 20;
    if (!carousel[i].hasClass("ready")) {
      if ($(this).find(".card-img img").hasClass("square")) {
        numberOfItems[i] = 4;
        nav0[i]=true;
        //stagePadding0[i]= Math.abs(numberOfItems[i] - 4) * 5;

      }

      $(carousel[i]).owlCarousel({
        center: true,
        loop: true,
        margin: 10,
        dots: false,
        smartSpeed: 500,
        stagePadding: 50,
        navText: [
          '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
          '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
        ],
        responsive: {
          0: {
            items: numberOfItems[i] - 1,
            nav: nav0[i],
            stagePadding: stagePadding0[i],
            //autoWidth: true,
          },
          480: {
            items: numberOfItems[i] - 1,
            nav: true,
            slideBy: numberOfItems[i] - 1,
          },
          960: {
            items: numberOfItems[i],
            nav: true,
            slideBy: numberOfItems[i],
          },
        },
      });

      $(carousel[i])
        .find(".card a")
        .on("click", function (e) {
          e.preventDefault();
          var item = $(this).attr("class");
          $(carousel[i]).find(".owl-item.center").removeClass("center");
          $(this).parent().parent().addClass("center");
          //$(".post-slide .captions .caption").hide();
          $(carousel[i]).parent().find(".captions .caption").hide();
          $(carousel[i])
            .parent()
            .find(".captions")
            .find("." + item)
            .show();
          return false;
        });

      //Start
      var startitem = $(carousel[i])
        .find(".owl-item.center .card a")
        .attr("class");
      $(".post-slide .captions")
        .find("." + startitem)
        .show();

      //Show actual page
      $(carousel[i]).on("changed.owl.carousel", function (event) {
        $($(carousel[i]).find(".owl-item .card a")[event.item.index]).trigger(
          "click"
        );
      });

      //Show on hover
      $(carousel[i])
        .find(".owl-item .card a")
        .hover(function () {
          $(this).trigger("click");
        });
      $(carousel[i]).addClass("ready");
    }
  });

  var owl1h = $(".post-slide-hirek .owl-carousel");
  if (!owl1h.hasClass("ready")) {
    owl1h.owlCarousel({
      center: true,
      items: 4,
      loop: true,
      margin: 10,
      dots: false,
      smartSpeed: 500,
      stagePadding: 50,
      nav: true,
      navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
      ],
      responsive: {
        0: {
          items: 1,
          nav: false,
          loop: true,
          rewind: true,
        },
        480: {
          items: 2,
          nav: true,
          slideBy: 1,
          loop: true,
          rewind: true,
          startPosition: 1,
        },
        960: {
          items: 3,
          nav: true,
          slideBy: 1,
          loop: true,
          rewind: true,
          startPosition: 1,
        },
      },
    });



    owl1h.find(".card a").on("click", function (e) {
      e.preventDefault();
      var itemH = $(this).attr("class");
      owl1h.find(".owl-item.center").removeClass("center");
      $(this).parent().parent().addClass("center");
      $(".post-slide .captions .caption").hide();
      $(".post-slide .captions")
        .find("." + itemH)
        .show();
      return false;
    });

    //Start
    var startitemH = owl1h.find(".owl-item.center .card a").attr("class");

    $(".post-slide .captions")
      .find("." + startitemH)
      .show();

    //Show actual page
    owl1h.on("changed.owl.carousel", function (event) {
      $(owl1h.find(".owl-item .card a")[event.item.index]).trigger("click");
    });

    //Show on hover
    owl1h.find(".owl-item .card a").hover(function () {
      $(this).trigger("click");
    });
    owl1h.addClass("ready");
  }


  var postCardsSlider = $(".post-cards .owl-carousel");
  var pc_carousel = [];
  postCardsSlider.each(function (i) {
    pc_carousel[i] = $(this);
    $(pc_carousel[i]).owlCarousel({
      center: true,
      items: 4,
      loop: true,
      margin: 10,
      dots: false,
      smartSpeed: 500,
      stagePadding: 50,
      nav: true,
      navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
      ],
      responsive: {
        0: {
          items: 1,
          nav: false,
          loop: true,
          rewind: true,
        },
        480: {
          items: 2,
          nav: true,
          slideBy: 1,
          loop: true,
          rewind: true,
          startPosition: 1,
        },
        960: {
          items: 3,
          nav: true,
          slideBy: 1,
          loop: true,
          rewind: true,
          startPosition: 1,
        },
      },
    });
  });





  //Video
  $(".yt-slider .owl-carousel").each(function () {
    $(this).owlCarousel({
      center: true,
      items: 2,
      loop: true,
      margin: 10,
      dots: false,
      smartSpeed: 1000,
      nav: true,
      navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
      ],
      responsive: {
        0: {
          items: 1,
          nav: false,
          stagePadding: 20, //30,
        },
        480: {
          items: 2,
          nav: true,
        },
      },
    });
  });

  $(".yt-slider2 .owl-carousel").each(function () {
    $(this).owlCarousel({
      center: true,
      items: 4,
      loop: true,
      margin: 10,
      dots: false,
      smartSpeed: 1000,
      nav: true,
      navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
      ],
      responsive: {
        0: {
          items: 1,
          nav: !1,
          stagePadding: 30,
        },
        720: {
          items: 2,
          nav: true,
        },
        960: {
          items: 3,
          nav: true,
        },
        1200: {
          items: 4,
          nav: true,
        },
      },
    });
  });

  $(".videolink").each(function () {
    if (!$(this).hasClass("ready")) {
      $(this).addClass("ready");
      $(this).on("click", function (e) {
        e.preventDefault();
        var current_carousel = $(this).parents(".owl-carousel");
        var item;
        var center_index = 0;
        var src = $(this).attr("data-src");
        if (current_carousel.length > 0) {
          center_index = current_carousel.find(".owl-item.center").index();
          item = $(this).parents(".owl-item");
          if (item.hasClass("center")) {
            showVideo(src);
          } else if (item.index() > center_index) {
            current_carousel.trigger("next.owl.carousel");
          } else if (item.index() < center_index) {
            current_carousel.trigger("prev.owl.carousel");
          }
        } else {
          showVideo(src);
        }
        return false;
      });
    }
  });
});

  // Events made easy


  var emeOwl = $(".month-select .eme-owl-carousel");

  function initEmeOwl() {
      var checkWidth = $(window).width();
      var currentMonth = emeOwl.parent(".month-select").attr("data-month");
      var startPos = parseInt(currentMonth) - 1;
      if (checkWidth > 767) {
          if (typeof emeOwl.data('owl.carousel') !== 'undefined') {
              emeOwl.data('owl.carousel').destroy();
          }
          emeOwl.removeClass('owl-carousel');
      } else if (checkWidth < 768) {
          if (!emeOwl.hasClass("owl-carousel")) {
              emeOwl.addClass("owl-carousel");
          }
          if (!emeOwl.hasClass("owl-loaded")) {
              emeOwl.owlCarousel({
                  center: true,
                  startPosition: startPos,
                  items: 5,
              });
          }
      }
  }

$(window).on("resize", function () {
    initEmeOwl();
});
$(window).on("load", function () {
    initEmeOwl();
});

